/* eslint-disable @typescript-eslint/naming-convention */
export enum ListType {
	SavedList = 'saved-lists',
	Favourites = 'favourites',
	PastOrders = 'past-orders',
	Trolley = 'trolley',
	SavedRecipes = 'saved-recipes',
}
